<svelte:head>
  <title>Offers | A Good Thing</title>
</svelte:head>

<div class="title">Business offers</div>
<div class="subtitle">View items on offer by local businesses.</div>

<h2 class="is-size-4 mb-5">
  <div class="field has-addons">
    <div class="control">
      <div class="select" style="font-size:1rem;">
        <select bind:value={distance}>
          <option value={1} selected={distance === 1}>1 mile</option>
          <option value={2} selected={distance === 2}>2 miles</option>
          <option value={3} selected={distance === 3}>3 miles</option>
          <option value={5} selected={distance === 5}>5 miles</option>
          <option value={10} selected={distance === 10}>10 miles</option>
          <option value={20} selected={distance === 20}>20 miles</option>
          <option value={30} selected={distance === 30}>30 miles</option>
          <option value={50} selected={distance === 50}>50 miles</option>
          <option value={100} selected={distance === 100}>100 miles</option>
          <option value={200} selected={distance === 200}>200 miles</option>
          <option value={500} selected={distance === 500}>500 miles</option>
        </select>
      </div>
    </div>
  </div>
</h2>

{#if items && items.length > 0}
  <OfferList {items} {requestsByOffer} {charityLocation} />
{:else if loading}
  Loading offers...
{:else}
  <article class="message is-success">
    <div class="message-body">
      No offers are currently active within {distance} miles(s). Try expanding the
      search.
    </div>
  </article>
{/if}

{#if nationwideItems && nationwideItems.length > 0}
  <hr class="mt-6" />
  <h2 class="subtitle is-size-4">Offers available nationwide via post</h2>
  <div class="block">
    <OfferList items={nationwideItems} {requestsByOffer} {charityLocation} />
  </div>
{/if}

<script lang="ts">
  import _ from 'lodash';
  import { appState } from '../../lib/appState';
  import OfferList from './_components/OfferList.svelte';

  let items: any[];
  let allNationwideItems: any[];
  $: nationwideItems =
    allNationwideItems && items
      ? _.differenceWith(allNationwideItems, items, (a, b) => a.id != b.id)
      : undefined;
  let requestsByOffer: any = {};

  let loading = false;
  let distance = 20;

  let firebase = window.firebase;

  $: charityLocation = $appState.charity?.location;

  getRequests();

  $: getOffers(distance);

  getNationwideOffers();

  async function getOffers(distance: number) {
    let params = {
      long: $appState.charity!.location!.coordinates[0],
      lat: $appState.charity!.location!.coordinates[1],
      distance,
    };

    loading = true;

    firebase
      .functions()
      .httpsCallable('api-offer-getoffers')(params)
      .then((response) => {
        items = response.data;
      })
      .finally(() => {
        loading = false;
      });
  }

  async function getNationwideOffers() {
    const result = await firebase
      .firestore()
      .collection('published_offers_v1')
      .where('options.nationwide', '==', true)
      .get();

    allNationwideItems = result.docs.map((doc: any) => ({
      id: doc.id,
      data: doc.data(),
    })) as any[];
  }

  async function getRequests() {
    firebase
      .firestore()
      .collection('requests_v2')
      .where('charity.id', '==', $appState.user!.charity)
      .onSnapshot((snap) => {
        let _requests = snap.docs.map((doc) => ({
          id: doc.id,
          data: doc.data() as Request_v2,
        }));

        requestsByOffer = _.keyBy(
          _requests,
          (r: Request_v2_Doc) => r.data.offer
        );
      });
  }
</script>
